import { render, staticRenderFns } from "./attachCustomer.vue?vue&type=template&id=c52cd20c&scoped=true&"
import script from "./attachCustomer.vue?vue&type=script&lang=js&"
export * from "./attachCustomer.vue?vue&type=script&lang=js&"
import style0 from "./attachCustomer.vue?vue&type=style&index=0&id=c52cd20c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52cd20c",
  null
  
)

export default component.exports